const EXT_MAP: Record<string, string> = {
  mpeg: "mp3",
  "x-wav": "wav",
  "x-aiff": "aiff",
  "x-m4a": "m4a",
  "x-flac": "flac",
  quicktime: "mov",
  "x-msvideo": "avi",
  "x-matroska": "mkv",
  mp2t: "ts",
  "octet-stream": "bin",
  "x-tar": "tar",
  gzip: "gz",
  "x-gzip": "gz",
  "x-bzip2": "bz2",
  "x-7z-compressed": "7z",
  "x-rar-compressed": "rar",
};

export function extensionFromMime(mime: string): string {
  const sub = mime.split("/")[1]?.toLowerCase() ?? "";
  return EXT_MAP[sub] ?? sub;
}

export function triggerDownload(href: string, name: string) {
  const a = document.createElement("a");
  a.href = href;
  a.download = name;
  a.click();
}
